export const TXTWCL_Check_thatXs_correct_and_try_a_ELL = {
  "id": "TXTWCL_Check_thatXs_correct_and_try_a_ELL",
  "defaultMessage": "Check that''s correct and try again"
} as const;

export const TXTWCL_SorryX_something_went_wrongX = {
  "id": "TXTWCL_SorryX_something_went_wrongX",
  "defaultMessage": "Sorry, something went wrong."
} as const;

export const TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL = {
  "id": "TXTWCL_SorryX_you_need_to_be_N0_or_ol_ELL",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "Sorry, you need to be {0} or older to join us"
} as const;

export const TXTWCL_Try_refreshing_the_pageX = {
  "id": "TXTWCL_Try_refreshing_the_pageX",
  "defaultMessage": "Try refreshing the page."
} as const;